export default __webpack_public_path__ + "static/media/twitterSocialIcon.40ec66ba.svg";